import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, URLSearchParams } from '@angular/http';

@Injectable()
export class PovConfigService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
    private baseUrl = 'api/povConfig';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/list`, options)
            .toPromise().then(this.extractData).catch(err => [JSON.parse(err._body)]);
    }

    getByPov(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getByPov`, options)
            .toPromise().then(this.extractData).catch(err => [JSON.parse(err._body)]);
    }

    getByPocIds(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getByPocIds`, options)
            .toPromise().then(this.extractData).catch(err => [JSON.parse(err._body)]);
    }

    addUpdate(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/addUpdate`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(err => [JSON.parse(err._body)]);
    }

    delete(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/delete`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(err => [JSON.parse(err._body)]);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/povConfig.service.ts